// Specialty configuration — single source of truth for all specialty definitions.
// prefix: prepended to Firestore collection names (empty string for PMR = backwards compatible)

export const SPECIALTIES = {
  pmr: {
    id: 'pmr',
    name: 'PM&R',
    fullName: 'Physical Medicine & Rehabilitation',
    prefix: '',
    color: 'primary',
    icon: 'fas fa-hospital',
  },
  pain: {
    id: 'pain',
    name: 'Pain Medicine',
    fullName: 'Pain Medicine',
    prefix: 'pain',
    color: 'danger',
    icon: 'fas fa-head-side-virus',
  },
  sports: {
    id: 'sports',
    name: 'Sports Medicine',
    fullName: 'Sports Medicine',
    prefix: 'sports',
    color: 'info',
    icon: 'fas fa-running',
  },
};

export const SPECIALTY_IDS = Object.keys(SPECIALTIES);
export const DEFAULT_SPECIALTY = 'pmr';

export const getSpecialty = (id) => SPECIALTIES[id] || SPECIALTIES[DEFAULT_SPECIALTY];
